import { Input } from "@/components/wensity/input";
import { Card, CardHeader } from "@/components/wensity/card";
import { DEFAULT_REMOTE_SUPPORT_LABEL, DEFAULT_REMOTE_SUPPORT_URL, type SiteMeta } from "@/data/site";

interface FooterLinkEditorProps {
  site: SiteMeta;
  onChange: (patch: Partial<SiteMeta>) => void;
}

export function FooterLinkEditor({ site, onChange }: FooterLinkEditorProps) {
  return (
    <Card className="border-[var(--color-border)] bg-[rgba(20,24,22,0.72)]">
      <CardHeader className="space-y-4">
        <div className="space-y-1">
          <h2 className="text-lg font-semibold">Remote support footer link</h2>
          <p className="text-sm text-[var(--color-muted)]">
            The link shown in the site footer. Both the label and URL are saved with your content.
          </p>
        </div>
        <Input
          label="Link label"
          hint={`Defaults to “${DEFAULT_REMOTE_SUPPORT_LABEL}” when left blank.`}
          value={site.remoteSupportLabel ?? ""}
          placeholder={DEFAULT_REMOTE_SUPPORT_LABEL}
          onChange={(event) => onChange({ remoteSupportLabel: event.target.value })}
        />
        <Input
          label="Link URL"
          type="url"
          hint={`Defaults to ${DEFAULT_REMOTE_SUPPORT_URL} when left blank.`}
          value={site.remoteSupportUrl ?? ""}
          placeholder={DEFAULT_REMOTE_SUPPORT_URL}
          onChange={(event) => onChange({ remoteSupportUrl: event.target.value })}
        />
      </CardHeader>
    </Card>
  );
}
